<ion-content class="teams-page-content">
  <div class="teams-page">
    <aside class="team-sidebar">
      <app-team-listing-sidebar
        [team]="selected.team"
        [canManageTeams]="canManageTeams"
        (teamChangeEvent)="teamChangeEventHandler($event)"
      >
      </app-team-listing-sidebar>
    </aside>
    <section class="team-content-wrapper" *ngIf="selected.team">
      <div class="team-content">
        <div class="team-content-header">
          <div class="team-content-heading">
            <ion-title>{{ selectedTeamName }}</ion-title>
            <p class="team-content-subtitle">{{ selectedTeamMemberCount }} Members</p>
            <span class="team-status-badge" [class.archived]="selectedTeamIsArchived">
              {{ selectedTeamIsArchived ? 'Archived Team' : 'Active Team' }}
            </span>
          </div>
          <a *ngIf="canManageTeamAccess" class="team-access-launch" [routerLink]="selectedTeamAccessLink">
            Team Permissions
          </a>
        </div>
        <nav class="team-view-tabs" aria-label="Team views">
          <a class="team-view-tab active" [routerLink]="selectedTeamMembersLink">Members</a>
          <a class="team-view-tab" [routerLink]="selectedTeamAccessLink">Permissions</a>
        </nav>
        <div class="team-listing-row">
          <app-team-members-listing [team]="selected.team" [canManageTeams]="canManageTeams"> </app-team-members-listing>
        </div>
      </div>
    </section>
  </div>
</ion-content>
